// Literales aprobados en pa3-textos.md, sección «Wizard de clínica».
export const PASOS = [
  { id: "medicos", label: "Médicos", cap: "agenda" },
  { id: "servicios", label: "Servicios", cap: "agenda" },
  { id: "horarios", label: "Horarios", cap: "agenda" },
  { id: "sofi", label: "Sofi", cap: "configuracion" },
  { id: "whatsapp", label: "WhatsApp", cap: "configuracion" },
  { id: "prueba", label: "Prueba a Sofi", cap: "configuracion" },
];
export const COPY_WIZARD = {
  titulo: "Configura tu clínica", continuar: "Guardar y continuar", anterior: "Anterior",
  salir: "Guardar y salir", retomar: "Retomar configuración", pendiente: "Pendiente", hecho: "Hecho",
  consulta: "Escribe como si fueras un paciente", enviar: "Enviar",
  aviso: "Esta prueba no crea citas ni envía mensajes.",
  error: "No pudimos obtener una respuesta. Inténtalo de nuevo.",
  limite: "Llegaste al límite de pruebas de hoy.", final: "Listo. Sofi ya tiene lo básico.",
};
export const wizardActivo = user => user?.wizard_clinicas === true && !user?.is_demo_session;
export const claveWizard = (user, tipo) => `surit:wizard:${user?.id}:${user?.active_clinic_id}:${tipo}`;
export const primerPendiente = (pasos, permitidos) => permitidos.find(p => pasos?.[p.id] !== true)?.id || permitidos[0]?.id;
